module.exports = __webpack_public_path__ + "static/media/select-down-arrow.970b49d0.svg";